import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Table } from '_zari/core'

import { ZrSwal } from 'utils'

import * as UsuarioService from 'services/usuario.service'

const AccionesCell = ({ row, actualizarTabla, username }) => {
  const __zariContext = React.useContext(ZariContext)

  // const clickDescargarFirma = React.useCallback(() => {}, [])

  const eliminarFirma = React.useCallback(() => {
    UsuarioService.eliminarFirmaxIdUsuarioxTipoFirma(username, row.tipoFirma)
      .then(() => {
        __zariContext.toast('success', 'El registro se ha eliminado.')
        actualizarTabla()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, username, row, actualizarTabla])

  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      tipo: 'error',
      mensaje: 'Seguro que desea eliminar el registro?',
      showCerrar: true,
      onSuccess: () => {
        eliminarFirma()
      }
    })
  }, [eliminarFirma])

  return (
    <Table.Cell>
      {/* <Button tiny outline onClick={clickDescargarFirma}>
        Descargar
      </Button> */}
      <Button tiny outline color='danger' onClick={clickEliminar}>
        Eliminar
      </Button>
    </Table.Cell>
  )
}

export default React.memo(AccionesCell)
